<template>
    <ItemTotalPrice
        :hasDiscount="props.hasDiscount"
        :totalAmount="totalItemPrice"
        :totalAmountAfterDiscount="totalItemPriceAfterDiscount"
        :discountType="props.discountType"
    />
</template>

<script setup lang="ts">
    import { DiscountType } from "@/data/model/Enums";
    import { computed } from "vue";

    import ItemTotalPrice from "./ItemTotalPrice.vue";

    const props = defineProps<{
        hasDiscount: boolean;
        quantity: number;
        unitPrice: number;
        unitPriceAfterDiscount?: number;
        discountType?: DiscountType;
    }>();

    const totalItemPrice = computed(() => props.quantity * props.unitPrice);
    const totalItemPriceAfterDiscount = computed(
        () => props.quantity * (props.unitPriceAfterDiscount ?? props.unitPrice)
    );
</script>
